import { VALID_SPLITPAY_TYPES } from "@swiggy-private/payment-types";

export interface SplitpayTestIds {
    CONTAINER: string;
    MAIN: string;
    MAIN_ICON: string;
    MAIN_TITLE: string;
    CHECK_BOX: string;
    PAYMENT_AMOUNT: string;
    BALANCE: string;
    ADD_MONEY_CTA: string;
    SELECTION_COMP: string;
}

const SPLITPAY_TEST_ID_PREFIX = {
    [VALID_SPLITPAY_TYPES.FLIPKARTSUPERCOIN]: "fk",
    [VALID_SPLITPAY_TYPES.SWIGGYPAY]: "spb",
    [VALID_SPLITPAY_TYPES.INTERMILES]: "tw_ntrmls", // used for test cases only
    [VALID_SPLITPAY_TYPES.YES_BANK]: "tw_ysbnk", // used for test cases only
};

const getSplitPayPrefix = (paymentCode: string): string => {
    const spCode = paymentCode.toUpperCase() as VALID_SPLITPAY_TYPES;
    return SPLITPAY_TEST_ID_PREFIX[spCode] ?? "spb";
};

export const getSplitPayBannerTestIds = (paymentCode: string): SplitpayTestIds => {
    const splitPayPrefix = getSplitPayPrefix(paymentCode);

    return {
        CONTAINER: `${splitPayPrefix}_container`,
        MAIN: `${splitPayPrefix}_main`,
        MAIN_ICON: `${splitPayPrefix}_icon`,
        MAIN_TITLE: `${splitPayPrefix}_title`,
        CHECK_BOX: `${splitPayPrefix}_cb`,
        ADD_MONEY_CTA: `${splitPayPrefix}_add_money_cta`,
        BALANCE: `${splitPayPrefix}_balance`,
        PAYMENT_AMOUNT: `${splitPayPrefix}_amt`,
        SELECTION_COMP: `${splitPayPrefix}_slctn_cmp`,
    };
};

export const SPLIT_PAY_BANNER_LIST_CONTAINER_TEST_ID = "split-pay-banner-list-container";
export const SPLIT_PAY_BANNER_TEST_ID = {
    OFFER_MESSAGE: "offer-message",
    BANNER_MESSAGE: "banner-message",
    DISABLE_MESSAGE: "disable-message",
};
